export const classes = {
  sectionHeader: {
    fontSize: 18,
    color: '#363B46',
    borderBottom: '1px solid #D6D6D6',
    margin: '32px 0 0',
    paddingBottom: 8,
  },
}
